import * as a from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/MapPinArea.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(t, { ref: r, ...o, weights: n }));
e.displayName = "MapPinAreaIcon";
const p = e;
export {
  p as MapPinArea,
  e as MapPinAreaIcon
};
